import React from "react";
import { useTranslation } from "react-i18next";
import meet from "../../assets/images/meeting1.jpg";
export default function CorporateTrainingComponente() {
    const { t } = useTranslation();
    
    return (
        <div
            className="tab-content-details-wrapper"
            style={{
                backgroundImage: `url(${meet})`,
                backgroundSize: "cover",
            }}
        >
            <div className="tab-label">
                <div>Customize, Manage &amp; Track Employee Training</div>
            </div>
        </div>
    );
}
